var backofficeUrl = 'https://cantonniers-bo-rec.suez.fr/#'
//var backofficeUrl = 'http://localhost:8082/#'
var baseUrl = 'https://cantonniers-api-rec.suez.fr/cantonniers/api/v1'
//var baseUrl = 'http://localhost:8080/cantonniers/api/v1'
var photoUrl = 'https://cantonniers-bo-rec.suez.fr/#/photo/'
//var photoUrl = 'http://localhost:8082/#/photo/'

 /* var backofficeUrl = 'https://cantonniers-bo-dev.azurewebsites.net/#'
 var baseUrl = 'https://cantonniers-dev.azurewebsites.net/cantonniers/api/v1'
 var photoUrl = 'cantonniers-bo-dev.azurewebsites.net/#/photo/' */

export {baseUrl, backofficeUrl, photoUrl}



// WEBPACK FOOTER //
// ./src/config.js